exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".absence-tile[data-v-7a3d6ff6]{border-radius:3px 4px;padding:4px;display:flex;justify-content:space-between;align-items:center;box-shadow:1px 1px 8px rgba(0,0,0,.2);margin:5px 0;cursor:pointer;color:#000}.absence-tile .cfg-button[data-v-7a3d6ff6]{border:1px solid rgba(0,0,0,.3);padding:2px;border-radius:9px}.absence-tile .cfg-button[data-v-7a3d6ff6]:hover{box-shadow:0 0 3px rgba(0,0,0,.5);cursor:pointer}", ""]);

// exports
